import React from 'react';
import PropTypes from 'prop-types';

var Error = function Error() {
  return React.createElement(
    "div",
    null,
    "Component Type not found on Selector"
  );
};

var Requite = function Requite(props) {
  var ErrorHandler = props.error || Error;
  var Handler = props.list[props.type] || ErrorHandler;
  return React.createElement(Handler, props);
};

Requite.propTypes = {
  error: PropTypes.any,
  list: PropTypes.object.isRequired,
  type: PropTypes.any.isRequired
};

export default Requite;
//# sourceMappingURL=index.es.js.map
